import { CLIENT_JOB_EVENT_PREFIX, JOB_DELAY_EVENT_PREFIX, fetchStatus, getConfigurableStatusParameters, setCurrentlyFetchingStatus } from "@devowl-wp/real-queue";
import { applyQueryString } from "@devowl-wp/utils";
import { SCAN_QUEUE_JOB } from "../../types";
let lastExecutionTimeMs = 0;
/**
 * Add listener for the scanner status and automatically update the UI.
 */ function listenScannerJobExecution() {
    document.addEventListener(`${JOB_DELAY_EVENT_PREFIX}${SCAN_QUEUE_JOB}`, (param)=>{
        let { detail: { isIdle, settings } } = param;
        const isInScannerTab = /page=real-cookie-banner(?:-pro)?-component#\/scanner/.test(window.location.href);
        if (isInScannerTab || isIdle) {
            if (lastExecutionTimeMs > 0 && lastExecutionTimeMs < settings.delay_ms) {
                // When the last execution to scan a page was "fast" enough (lower than our default delay)
                // then we can use the execution time as our delay.
                settings.delay_ms = lastExecutionTimeMs / 2;
            }
        } else {
            settings.delay_ms = 3000;
        }
    });
    document.addEventListener(`${CLIENT_JOB_EVENT_PREFIX}${SCAN_QUEUE_JOB}`, (param)=>{
        let { detail: { job: { id, data: { url }, process_total, group_position, group_total, group_uuid }, resolve, reject, saveJobResult } } = param;
        const executeThis = async (url)=>{
            const finalUrl = new URL(url);
            // Do not modify the URL when it e.g. is a redirection and has already the correct query parameters
            // Who knows? Perhaps a webserver redirects to a A-Z ordered query list?!
            const { searchParams } = finalUrl;
            const hasAlreadyCorrectParams = searchParams.get("rcb-scan") === "1" && searchParams.get("rcb-scan-job") === `${id}`;
            if (!hasAlreadyCorrectParams) {
                applyQueryString(finalUrl, [
                    {
                        "rcb-scan": `-${window.btoa(JSON.stringify(getConfigurableStatusParameters()))}-`,
                        "rcb-scan-job": id
                    }
                ], true);
            }
            const link = `<a href="${url}" target="_blank">${url}</a>`;
            try {
                const response = await window.fetch(finalUrl.toString(), {
                    mode: "no-cors"
                });
                const { ok, status, statusText, type, headers, redirected, url: responseUrl } = response;
                const isCors = type === "opaque";
                // Check if page could be scanned successfully
                if (redirected) {
                    // We cannot ensure 100% if this site got scanned successfully, let's do it again
                    executeThis(responseUrl);
                } else if (ok || // See https://developer.mozilla.org/en-US/docs/Web/API/Response/type
                // We should definitely ignore CORS
                isCors) {
                    var _headers_get;
                    await fetchStatus({
                        from: "html",
                        html: await response.text()
                    });
                    // Immediate update the status to show at least "1 %" in tab
                    if (group_uuid && (group_position === group_total || group_position === 1)) {
                        fetchStatus(true);
                    }
                    // A cors request never can mark the job as complete, we need to manually do this
                    if (isCors) {
                        await saveJobResult(id, process_total);
                    }
                    // We requested a file (what does this do in our sitemap? Just ignore)
                    const contentType = (_headers_get = headers.get("content-type")) == null ? void 0 : _headers_get.toLowerCase();
                    if (contentType && !contentType.startsWith("text/")) {
                        await saveJobResult(id, process_total);
                    }
                    resolve();
                } else if ([
                    404,
                    410
                ].indexOf(status) > -1) {
                    // We request a site which does no longer exist (perhaps not deleted from sitemap?) -> ignore
                    await saveJobResult(id, process_total);
                    resolve();
                } else {
                    reject({
                        code: `invalid_response_${status}`,
                        message: `${statusText} (${link})`
                    });
                }
            } catch (e) {
                reject({
                    code: "unexpected",
                    message: `${e.toString()} (${link})`
                });
            }
        };
        const start = new Date().getTime();
        setCurrentlyFetchingStatus(true);
        executeThis(url).finally(()=>{
            setCurrentlyFetchingStatus(false);
            lastExecutionTimeMs = new Date().getTime() - start;
        });
    });
}
export { listenScannerJobExecution };
